import { DEMO_URLS } from "./constants";

export const NOT_FOUND_URL = "/404";
export const INTERNAL_SERVER_ERROR_URL = "/500";
export const GENERIC_ERROR_URL = "/error";

export const ADMIN_URL = "/admin/slapshot/";

export const SLAPSHOT_AUTH = "/auth";

export const SLAPSHOT_LOGIN_URL = `${SLAPSHOT_AUTH}/login`;
export const SLAPSHOT_FORGOT_PASSWORD_URL = `${SLAPSHOT_AUTH}/forgot-password`;
export const SLAPSHOT_RESET_PASSWORD_URL = `${SLAPSHOT_AUTH}/reset-password/:userIdentifier/:token`;
export const SLAPSHOT_SET_PASSWORD_URL = `${SLAPSHOT_AUTH}/set-password/:userIdentifier/:token`;
export const SLAPSHOT_VERIFY_EMAIL_URL = `${SLAPSHOT_AUTH}/verify-email`;
export const SLAPSHOT_VERIFY_2FA_URL = `${SLAPSHOT_AUTH}/verify-2fa`;

export const SLAPSHOT_REGISTER_URL = `${SLAPSHOT_AUTH}/register`;

export const SLAPSHOT_HOME_URL = "/";
export const SLAPSHOT_PROFILE_URL = `${SLAPSHOT_HOME_URL}profile`;
export const SLAPSHOT_MY_PLAN_URL = `${SLAPSHOT_PROFILE_URL}/plan`;
export const SLAPSHOT_MY_PLAN_UPGRADE_URL = `${SLAPSHOT_MY_PLAN_URL}/upgrade`;
export const SLAPSHOT_API_URL = `${SLAPSHOT_PROFILE_URL}/api`;
export const SLAPSHOT_SUBSCRIPTION_URL = `${SLAPSHOT_HOME_URL}subscription`;
export const SLAPSHOT_SUBSCRIPTION_UPGRADE_URL = `${SLAPSHOT_SUBSCRIPTION_URL}/upgrade`;

// export const SLAPSHOT_PROJECTS_URL = `${SLAPSHOT_HOME_URL}projects`;

export const SLAPSHOT_WORKSPACES_URL = `${SLAPSHOT_HOME_URL}workspaces`;

export const SLAPSHOT_LAYER_URL = `${SLAPSHOT_HOME_URL}projects/:projectId/:serviceParam/shots/:shotId/layers/:layerId`;

export const SLAPSHOT_SHOT_URL = `${SLAPSHOT_HOME_URL}projects/:projectId/:serviceParam/shots/:shotId`;

export const SLAPSHOT_PROJECT_URL = `${SLAPSHOT_HOME_URL}projects/:projectId`;
export const SLAPSHOT_SERVICE_URL = `${SLAPSHOT_PROJECT_URL}/:serviceParam`;

export const SLAPSHOT_DOWNLOADS = `${SLAPSHOT_HOME_URL}downloads`;

export const SLAPSHOT_SETTINGS = `${SLAPSHOT_HOME_URL}settings`;

export const SLAPSHOT_INVITE_USER = `${SLAPSHOT_HOME_URL}invite-member`;
export const SLAPSHOT_INVITE_ACCEPT = `${SLAPSHOT_HOME_URL}invite-accept`;

/** Support article: 3D / camera tracking. */
export const SLAPSHOT_CAMERA_TRACKING_GUIDE_URL =
  "https://support.slapshot.ai/en/support/how-do-i-create-3d-tracks-with-ai-in-slapshot";

/** Support article: Motion Vectors (ROI / full shot, generation workflow). */
export const SLAPSHOT_MOTION_VECTORS_GUIDE_URL =
  "https://support.slapshot.ai/en/support/what-are-motion-vectors-and-how-do-you-generate-them";

/** Support article: ComfyUI nodes setup. */
export const SLAPSHOT_COMFYUI_GUIDE_URL =
  "https://support.slapshot.ai/en/support/slapshot-comfy-ui-setup-guide";

/**
 * Motion Vectors “Add ROI” guide modal video (same source as demo URLs).
 * Override at build time with VITE_SMART_VECTORS_ROI_GUIDE_VIDEO_URL (e.g. CloudFront or another bucket).
 * Set to an empty string to show a blank panel.
 */
export const SMART_VECTORS_GUIDE_VIDEO_URL =
  import.meta.env.VITE_SMART_VECTORS_ROI_GUIDE_VIDEO_URL !== undefined
    ? import.meta.env.VITE_SMART_VECTORS_ROI_GUIDE_VIDEO_URL
    : DEMO_URLS.smartVectorsRoiGuide;
